module.exports = __webpack_public_path__ + "img/logo_mdic.0699db67.png";